<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap mb-3">
            <div>
                <h5>
                    <span
                        @click="hasHistory()
                        ? $router.go(-1)
                        : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Заказ
                    <router-link v-b-tooltip.hover
                      :title="'Перейти к заказу #' + editedItem.order_id"
                      :to="{
                        query: {
                          order: editedItem.order_id
                        }
                      }"
                    >#{{editedItem.order_id}}</router-link>.
                    {{editedItem.service_name}}
                </h5>
            </div>
            <div class="d-flex align-items-center">
                <div>
                    <button v-if="chooseActiveButton(303)" @click="changeStatus(304)" type="button" class="btn btn-outline-green mr-3"> Взять в работу</button>
                    <button v-if="chooseActiveButton(304)" @click="changeStatus(305)" type="button" class="btn btn-outline-red mr-3"> Приостановить</button>
                    <button v-if="chooseActiveButton(305)" @click="changeStatus(304)" type="button" class="btn btn-outline-primary mr-3"> Вернуть в работу</button>
                    <button v-if="chooseActiveButton(304)" @click="changeStatus(306)" type="button" class="btn btn-outline-green mr-3"> Завершить</button>
                    <button v-if="chooseActiveButton(306)" @click="changeStatus(307)" type="button" class="btn btn-outline-green mr-3"> Закрыть</button>
                </div>
            </div>
        </div>

        <div class="row active-panel-block align-items-center m-0 mb-3">
            <div class="active-panel-block_icon">
                <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
            </div>
            <div class="active-panel-block_one">
                <span class="text-bold-size-13 text-secondary">
                    <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                    <span class="font-weight-light">{{ getManagerName() || "Не известно" }}</span>
                </span>
            </div>
            <div class="text-bold-size-13 active-panel-block_two font-weight-bold text-uppercase cursor-pointer">
                <span class="text-secondary mr-3" v-if="!editMode" @click="editMode=true">Редактировать</span>
                <span class="text-success mr-3" v-if="editMode" @click="save()">Сохранить</span>
                <span class="text-secondary mr-3" v-if="editMode" @click="editMode=false">Отменить</span>

                <span class="font-weight-bold text-uppercase text-secondary"><i class="fas fa-info-circle text-orange mr-1"></i> Статус:</span>
                <span class="font-weight-light text-uppercase text-secondary mr-2">{{ getStatusName() }}</span>
            </div>
        </div>

        <div class="position-relative">
            <b-table-simple small caption-top stacked borderless class="service-properties-table">
                <b-thead head-variant="dark">
                    <b-tr>
                        <b-th
                            v-for="item in editedItem.data"
                            :key="item.id"
                        >{{ item.reference_service_property_name }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td
                            :stacked-heading="item.reference_service_property_name + ':'"
                            v-for="(item, index) in editedItem.data"
                            :key="item.id"
                            :class="item.group_id ? `grouped-prop grouped-prop-${item.reference_service_property_id}`:''"
                        >
                            <template v-if="!editMode">
                                <template v-if="item.reference==0">
                                    <template v-if="!excludePropertyFromTextFiltering(item.reference_service_property_id) && (item.reference_service_property_name.indexOf('Дата и время') !== -1 || item.reference_service_property_name.indexOf('дата и время') !== -1)">
                                        {{ (item.value || 'Нет данных') | formattedDateTime }}
                                    </template>
                                    <template v-else-if="!excludePropertyFromTextFiltering(item.reference_service_property_id) && (item.reference_service_property_name.indexOf('Срок действия') !== -1 || item.reference_service_property_name.indexOf('Дата') !== -1 || item.reference_service_property_name.indexOf('дата') !== -1)">
                                        {{ (item.value || 'Нет данных') | formattedDate }}
                                    </template>
                                    <template v-else>
                                        {{ item.value || 'Нет данных' }}
                                    </template>
                                </template>
                                <template v-if="item.reference!=0">
                                    {{ getPropertyNameByValue(item.value) }}
                                </template>
                            </template>
                            <template v-if="editMode">
                                <template v-if="item.reference==0">
                                    <template v-if="!actionReferenceProperties[editedItem.data[index].reference_service_property_id]">
                                        <template v-if="item.reference_service_property_name.indexOf('Дата и время') !== -1 || item.reference_service_property_name.indexOf('дата и время') !== -1">
                                            <b-form-input v-model="editedItem.data[index].value" type="datetime-local" size="sm" placeholder=""></b-form-input>
                                        </template>
                                        <template v-else-if="item.reference_service_property_name.indexOf('Срок действия') !== -1 || item.reference_service_property_name.indexOf('Дата') !== -1 || item.reference_service_property_name.indexOf('дата') !== -1">
                                            <b-form-input v-model="editedItem.data[index].value" type="date" size="sm" placeholder=""></b-form-input>
                                        </template>
                                        <template v-else-if="item.reference_service_property_name.indexOf('Время') !== -1 || item.reference_service_property_name.indexOf('время') !== -1">
                                            <b-form-input v-model="editedItem.data[index].value" type="time" size="sm" placeholder=""></b-form-input>
                                        </template>
                                        <template v-else-if="item.reference_service_property_name.indexOf('Комментарий') !== -1 || item.reference_service_property_name.indexOf('комментарий') !== -1">
                                            <b-form-textarea
                                                id="textarea"
                                                v-model="editedItem.data[index].value"
                                                placeholder="Введите ваш комментарий..."
                                                rows="3"
                                                max-rows="6"
                                            ></b-form-textarea>
                                        </template>
                                        <template v-else>
                                            <b-form-input v-model="editedItem.data[index].value" size="sm" placeholder=""></b-form-input>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id]">
                                            <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].type == 'number'">
                                                <b-form-input
                                                    v-model="editedItem.data[index].value"
                                                    size="sm"
                                                    type="number"
                                                    :readonly="actionReferenceProperties[editedItem.data[index].reference_service_property_id].readonly"
                                                    :min="actionReferenceProperties[editedItem.data[index].reference_service_property_id].min_value"
                                                ></b-form-input>
                                            </template>
                                            <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].type == 'text'">
                                                <b-form-input
                                                    v-model="editedItem.data[index].value"
                                                    size="sm"
                                                    type="text"
                                                    :readonly="actionReferenceProperties[editedItem.data[index].reference_service_property_id].readonly"
                                                ></b-form-input>
                                            </template>
                                            <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].type == 'inline'">
                                                {{editedItem.data[index].value}}
                                            </template>
                                            <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].type == 'group'">
                                                <b-form-row>
                                                    <b-col>
                                                        <b-form-input
                                                            v-model="editedItem.data[index].value"
                                                            size="sm"
                                                            type="text"
                                                        ></b-form-input>
                                                    </b-col>
                                                    <b-col cols="12" md="auto">
                                                        <template v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].create_doubles">
                                                            <b-button
                                                                size="sm"
                                                                class="ml-2 mt3px"
                                                                variant="success"
                                                                title="Добавить"
                                                                @click="addNewFieldByField(index)"
                                                            ><b-icon icon="plus" font-scale="1.2"></b-icon></b-button>
                                                            <b-button
                                                                v-if="actionReferenceProperties[editedItem.data[index].reference_service_property_id].count > 1"
                                                                size="sm"
                                                                class="ml-2 mt3px"
                                                                variant="danger"
                                                                title="Удалить"
                                                                @click="deleteField(index)"
                                                            ><b-icon icon="x" font-scale="1.2"></b-icon></b-button>
                                                        </template>
                                                    </b-col>
                                                </b-form-row>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <b-form-input v-model="editedItem.data[index].value" size="sm" placeholder=""></b-form-input>
                                        </template>
                                    </template>
                                </template>
                                <template v-if="item.reference!=0">
                                    <tsoft-select-of-properties
                                        :reference_id="item.reference"
                                        :needGroups="item.reference==5 ? true:false"
                                        :needNullElement="true"
                                        :selected="item.value"
                                        :index="index"
                                        @set="setReferenceValue"
                                    ></tsoft-select-of-properties>
                                </template>
                            </template>
                        </b-td>
                    </b-tr>
                </b-tbody>
                <caption>
                    <b-row class="align-items-center">
                        <b-col>
                            <b-form-checkbox v-model="checkedLoadDocument" name="check-button" switch class="mr-4">
                                <span class="text-bold-size-13">Прикрепить документ</span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </caption>
            </b-table-simple>
            <div class="document_upload" v-if="checkedLoadDocument">
                <tsoft-create-documents
                    :needMultiUploadDocuments="true"
                    :orderServiceId="editedItem.id"
                    :orderId="editedItem.order_id"
                    :companyId="editedItem.company_id"
                    :needUploadButton="true"
                    @documentLoaded="onCloseSidePanelLoadingDocument"
                />
            </div>
            <div class="document_view_order" v-if="editedItem.documents.length > 0 || this.updateDocumentListCounter > 0">
                <h5>Документы по услуге</h5>
                <tsoft-show-edit-documents
                    :orderId="editedItem.order_id"
                    :orderServiceId="editedItem.id"
                    :companyId="editedItem.company_id"
                    :requestDocuments="requestDocuments"
                    :updateDocumentList.sync="updateDocumentListCounter"
                />
            </div>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </div>
</template>

<script>
    import {
        API_PUT_ORDER_SERVICES,
        API_POST_ORDERS_SERVICES_MASS_SAVE,
        API_ORDERS_SERVICE_PROPERTY,
        SERVICE_TO_DOCUMENT
    } from "../constants"

    import {
        constantsAllReferenceProperties,        // @TODO Move to VUEX
        defaultDataItems,
    } from "../mixins"

    export default {
        metaInfo() {
            return {
                title: `Заказ #${this.editedItem.order_id}`
            }
        },
        mixins: [
            constantsAllReferenceProperties,
            defaultDataItems,
        ],
        data() {
            return {
                dataOverlay: true,
                editedItem: {
                    order_id: '',
                    service_name: '',
                    data: [],
                    users: [],
                    documents: [],
                    company_documents: [],
                    finance: []
                },
                editMode: false,
                checkedLoadDocument: false, //do i need a document
                requestDocuments: true,
                updateDocumentListCounter: 0,
                actionReferenceProperties: {
                    253: {
                        control_ids: [253],    // See reference_properties table
                        count: 0,
                        type: 'group',
                        create_doubles: true,
                        default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                        readonly: false,
                        increment_id: 252       // Счетчик полей в БД
                    },
                    257: {
                        control_ids: [257, 258, 259],    // See reference_properties table
                        count: 0,
                        type: 'group',
                        create_doubles: true,
                        default_name: 'Номер ДТ',
                        readonly: false,
                        increment_id: 256       // Счетчик полей в БД
                    },
                    274: {
                        control_ids: [274],     // See reference_properties table
                        count: 0,
                        type: 'group',
                        create_doubles: true,
                        default_name: 'Номер транспортной накладной (BL, CMR, MAWB)',
                        readonly: false,
                        increment_id: 273       // Счетчик полей в БД
                    },
                    276: {
                        control_ids: [276],        // See reference_properties table
                        count: 0,
                        type: 'group',
                        create_doubles: true,
                        default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                        readonly: false,
                        increment_id: 275       // Счетчик полей в БД
                    },
                    252: {
                        type: 'inline'
                    },
                    256: {
                        type: 'inline'
                    },
                    273: {
                        type: 'inline'
                    },
                    275: {
                        type: 'inline'
                    },

                },
            }
        },
        created() {
            this.index();
        },
        methods: {
            hasHistory () {
                return window.history.length > 2
            },
            groupFields() {
                const sortServicePropertiesByOrderNumber = (a, b) => {
                    return (a['reference_service_property_ordering_number'] > b['reference_service_property_ordering_number'] && 1) ||
                    (a['reference_service_property_ordering_number'] === b['reference_service_property_ordering_number'] ? 0 : -1)
                }

                const groupServicePropertiesId = (a, b) => {
                    return (a['reference_service_property_id'] > b['reference_service_property_id'] && 1) ||
                        (a['reference_service_property_id'] === b['reference_service_property_id'] ? 0 : -1)
                }

                const groupServicePropertiesByGroupId = (a, b) => {
                    a['group_id'] = a['group_id'] ? a['group_id'] : 0
                    b['group_id'] = b['group_id'] ? b['group_id'] : 0

                    return (a['group_id'] > b['group_id'] && 1) ||
                        (a['group_id'] === b['group_id'] ? 0 : -1)
                }

                this.editedItem.data = this.editedItem.data.sort(groupServicePropertiesId)
                this.editedItem.data = this.editedItem.data.sort(groupServicePropertiesByGroupId)
                this.editedItem.data = this.editedItem.data.sort(sortServicePropertiesByOrderNumber)

                this.actionReferenceProperties[253].count = 0
                this.actionReferenceProperties[257].count = 0
                this.actionReferenceProperties[274].count = 0
                this.actionReferenceProperties[276].count = 0
                this.editedItem.data.forEach((item, index) => {
                    let nowPropertyId = item.reference_service_property_id
                    if (this.actionReferenceProperties[nowPropertyId]) {
                        // If we have counter - increase it
                        if (this.actionReferenceProperties[nowPropertyId].count >= 0) {
                            item.reference_service_property_name = this.actionReferenceProperties[nowPropertyId].default_name
                            this.actionReferenceProperties[nowPropertyId].count++
                            item.reference_service_property_name += ' ' + this.actionReferenceProperties[nowPropertyId].count
                        }
                    }
                })
                // update increments ids counts
                this.editedItem.data.forEach((item, index) => {
                    let nowPropertyId = item.reference_service_property_id
                    switch(nowPropertyId) {
                        case this.actionReferenceProperties[253].increment_id:
                            item.value = this.actionReferenceProperties[253].count
                            break
                        case this.actionReferenceProperties[257].increment_id:
                            item.value = this.actionReferenceProperties[257].count
                            break
                        case this.actionReferenceProperties[274].increment_id:
                            item.value = this.actionReferenceProperties[274].count
                            break
                        case this.actionReferenceProperties[276].increment_id:
                            item.value = this.actionReferenceProperties[276].count
                            break
                    }

                })
            },
            setDocumentRelation() {
                let service_id = this.$route.params.service_id
                if (SERVICE_TO_DOCUMENT[service_id] && this.editedItem.company_documents.length > 0) {
                    let find_document_by_property_id = SERVICE_TO_DOCUMENT[service_id]
                    this.editedItem.company_documents.forEach((document, index) => {
                        // @TODO: ПЕРЕДЕЛАТЬ, ОРИЕНТИРОВАТЬСЯ НА ИНДЕКСЫ - ПЛОХО
                      if ((typeof find_document_by_property_id === 'string' && find_document_by_property_id.indexOf(document.reference_document_type_id, 0) != -1)
                            || find_document_by_property_id == document.reference_document_type_id) {
                          this.editedItem.data[0].value = !this.editedItem.data[0].value ? document.name : this.editedItem.data[0].value
                          this.editedItem.data[1].value = !this.editedItem.data[1].value ? document.date_of_document : this.editedItem.data[1].value
                      }
                    })
                }
            },
            index() {
                api.call("get", `/api/orders/${this.$route.params.order_id}/services/${this.$route.params.service_id}`).then(({data}) => {
                    this.editedItem = data
                    this.groupFields()
                    this.setDocumentRelation()
                    this.dataOverlay = false
                })
            },
            save() {
                this.dataOverlay = true
                api.call("post", API_POST_ORDERS_SERVICES_MASS_SAVE, { order_service_properties: this.editedItem.data, order_id: this.editedItem.order_id }).then(({data}) => {
                    this.editMode = false
                    this.dataOverlay = false
                    this.makeToast('success', 'Успешно сохранено')
                })
            },
            chooseActiveButton(onShowId) {
                if (this.editedItem.reference_property_status_id == onShowId) {
                    return true
                }
                return false
            },
            changeStatus(reference_property_status_id) {
                this.dataOverlay = true
                this.editedItem.reference_property_status_id = reference_property_status_id

                api.call("put", `${API_PUT_ORDER_SERVICES}/${this.editedItem.id}`, {
                    reference_property_status_id: this.editedItem.reference_property_status_id
                }).then(({data}) => {
                    this.index()
                }).finally(() => (
                    this.dataOverlay = false
                ))
            },
            setReferenceValue(value, reference_id, index) {
                this.editedItem.data[index].value = value
            },
            getPropertyNameByValue(value) {
                let result = 'Нет данных'
                if (value && this.referencePropertiesList[value]) {
                    result = this.referencePropertiesList[value]['text']
                }
                return result
            },
            getManagerName() {
                let name = "Не назначен"
                if (this.editedItem.users.length > 0) {
                    name = this.editedItem.users[0].name
                }
                return  name
            },
            getStatusName() {
                let name = "Не известен"
                if (this.editedItem.status && this.editedItem.status.name) {
                    name = this.editedItem.status.name
                }
                return  name
            },
            excludePropertyFromTextFiltering(property_id) {
                let excludeArray = [253, 276]
                if (excludeArray.includes(property_id)) {
                    return true
                }
                return false
            },
            addNewFieldByField(index) {
                this.dataOverlay = true

                let nowPropertyId = this.editedItem.data[index].reference_service_property_id

                const addElement = {
                    order_service_id: this.editedItem.data[index].order_service_id,
                    reference: this.editedItem.data[index].reference,
                    reference_service_property_id: nowPropertyId
                }
                api.call("post", API_ORDERS_SERVICE_PROPERTY, addElement).then(({data}) => {
                    this.actionReferenceProperties[nowPropertyId].count++
                    this.editedItem.data = this.editedItem.data.concat(data.reverse())
                    this.groupFields()
                    this.dataOverlay = false
                    this.makeToast('success', 'Успешно сохранено')
                })
            },
            // closing after loading the document
            onCloseSidePanelLoadingDocument(value) {
                this.updateDocumentListCounter++
            },
            deleteField(index) {
                let id = this.editedItem.data[index].id
                let nowPropertyId = this.editedItem.data[index].reference_service_property_id

                this.$swal({
                    title: 'Подтвердите удаление',
                    icon: 'question',
                    showCancelButton: true,
                    cancelButtonText: 'Нет',
                    confirmButtonText: 'Да',
                }).then((result) => {
                    if(result.isConfirmed){
                        this.dataOverlay = true
                        api.call("delete", `${API_ORDERS_SERVICE_PROPERTY}/${id}`).then(({data}) => {
                            this.actionReferenceProperties[nowPropertyId].count--
                            this.editedItem.data.splice(index, this.actionReferenceProperties[nowPropertyId].control_ids.length)
                            this.groupFields()
                        }).finally(() => {
                            this.dataOverlay = false
                            this.makeToast('danger', 'Данные удалены')
                        })
                    }
                })
            }
        }
    }
</script>
